import { select, Store } from '@ngrx/store';
import { debounceTime } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { AppState } from '../../../../core/reducers';
import { BaseDataSource, QueryResultsModel } from '../../../../core/_base/crud';
import { Document } from '../models';
import {
  selectDocumentPage,
  selectDocumentPageLoading,
  selectDocumentShowInitWaitingMessage,
} from '../selectors';

export class DocumentDataSource extends BaseDataSource {
  private _documents: Document[];

  constructor(private store: Store<AppState>, private paginator: MatPaginator) {
    super();

    this.loading$ = this.store.select(selectDocumentPageLoading);
    this.isPreloadTextViewed$ = this.store.select(selectDocumentShowInitWaitingMessage);

    this.store
      .pipe(select(selectDocumentPage), debounceTime(500))
      .subscribe((res: QueryResultsModel) => {
        this._documents = res.items;

        this.entitySubject.next(res.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(res.totalCount);
      });
  }

  get documents() {
    return this._documents;
  }
}
